import { CLIENT_MANAGER_ROLE_ID, getMenuSections } from "../../config/menuConfig";
import { roleRoutes } from "../../utils/roles";

// ─────────────────────────────────────────────────────────────────────────────
// El menú del portal del comercio, visto desde las Novedades: qué roles son
// comercio y qué ítems puede señalar una novedad ("Dónde está" y etiqueta
// "Nuevo").
// ─────────────────────────────────────────────────────────────────────────────

/** Roles del portal del comercio: cliente y gestor de comercio (por `_id`). */
export function isCommerceRole(role) {
  return role === roleRoutes.client || role === CLIENT_MANAGER_ROLE_ID;
}

/**
 * Todos los ítems que puede tener el menú de un comercio, incluidos los que
 * dependen de su configuración (flota propia, módulos habilitados): una
 * novedad puede señalar uno que solo algunos comercios tienen.
 * @returns {{ path: string, label: string, section: string }[]}
 */
export function commerceMenuItems() {
  const sections = getMenuSections(roleRoutes.client, undefined, {
    hasOwnFleet: true,
    tenantType: "company",
    tenantModules: ["rutificador"],
  });
  const seen = new Set();
  const items = [];
  for (const section of sections) {
    for (const item of section.items ?? []) {
      if (!item.path || seen.has(item.path)) continue;
      seen.add(item.path);
      items.push({ path: item.path, label: item.label, section: section.title });
    }
  }
  return items;
}

/** Etiqueta (clave i18n) del ítem del menú con esa ruta, o null. */
export function commerceMenuLabelOf(path) {
  return commerceMenuItems().find((item) => item.path === path)?.label ?? null;
}

/**
 * Botón principal del detalle: el que definió quien redactó la novedad o, si no
 * hay, "Ir a <ítem del menú>" cuando la novedad dice dónde está.
 * @returns {{ label: string, url: string } | null}
 */
export function primaryActionOf(news, t) {
  if (news?.cta) return news.cta;
  const menuPath = news?.location?.menuPath;
  const menuLabel = menuPath ? commerceMenuLabelOf(menuPath) : null;
  return menuLabel ? { label: t("Ir a {{section}}", { section: t(menuLabel) }), url: menuPath } : null;
}
